// Keeps the prices (and the old price when discounted) on the "Cards" and "List" variant styles right after a choice changes
// (snippets/gd-variant-option.liquid prints the first prices; this only refreshes them).
(function () {
  if (window.__gdVariantStyles) return;
  window.__gdVariantStyles = true;

  function money(cents) {
    var format = window.MinimogSettings && window.MinimogSettings.money_format;
    if (typeof window.formatMoney === 'function' && format) return window.formatMoney(cents, format);
    return (cents / 100).toFixed(2);
  }

  // Same variant data the theme's picker uses (fetched in the page language), so the values match the buttons on /ar too.
  function variantsOf(container) {
    var picker = container.querySelector('variant-picker');
    if (picker && picker.productData && picker.productData.variants) return picker.productData.variants;
    var json = container.querySelector('#productVariants');
    if (!json) return null;
    try { return JSON.parse(json.textContent); } catch (e) { return null; }
  }

  function refresh(container) {
    var variants = variantsOf(container);
    if (!variants) return;
    var fields = Array.prototype.slice.call(container.querySelectorAll('[data-picker-field]'));
    var selected = fields.map(function (field) {
      if (field.dataset.pickerField === 'radio') {
        var checked = field.querySelector('input:checked');
        return checked ? checked.value : null;
      }
      var select = field.querySelector('select');
      return select ? select.value : null;
    });

    container.querySelectorAll('[data-gd-vopt]').forEach(function (group) {
      var pos = Number(group.dataset.gdVopt) - 1;
      var prices = [];
      group.querySelectorAll('[data-gd-vopt-price]').forEach(function (el) {
        var node = el.closest('.m-product-option--node');
        if (!node) return;
        var value = node.dataset.value;
        var wanted = selected.slice();
        wanted[pos] = value;
        var variant = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === wanted[i]; });
        }) || variants.find(function (v) { return v.options[pos] === value; });
        if (!variant) return;
        var now = el.querySelector('[data-gd-vopt-now]');
        var was = el.querySelector('[data-gd-vopt-was]');
        var onSale = variant.compare_at_price > variant.price;
        if (now) {
          now.textContent = money(variant.price);
          now.classList.toggle('gd-vopt__now--sale', onSale);
        }
        if (was) {
          was.textContent = onSale ? money(variant.compare_at_price) : '';
          was.hidden = !onSale;
        }
        prices.push(variant.price);
      });
      var same = prices.length > 1 && prices.every(function (p) { return p === prices[0]; });
      group.classList.toggle('gd-vopt--same-price', same);
    });
  }

  // The theme can switch a choice by itself when a combination does not exist; it announces the new variant here.
  function watchOne(container) {
    if (!window.MinimogEvents || container.__gdWatched || !container.querySelector('[data-gd-vopt-price]')) return;
    container.__gdWatched = true;
    window.MinimogEvents.subscribe(container.dataset.productId + '__VARIANT_CHANGE', function () { refresh(container); });
  }
  function watch() {
    document.querySelectorAll('[data-variant-picker]').forEach(watchOne);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  // Also covers pickers added later, like the quick view.
  document.addEventListener('change', function (event) {
    var container = event.target && event.target.closest && event.target.closest('[data-variant-picker]');
    if (!container || !container.querySelector('[data-gd-vopt-price]')) return;
    watchOne(container);
    window.requestAnimationFrame(function () { refresh(container); });
  });
})();
